import { IProductType } from '../../common/interfaces';
import { BaseEntity } from './base.entity';

export class ProductType extends BaseEntity implements IProductType {
    code: string;
    label: string;
}